/**
 * Created by yougen.zhuangyg on 2014/11/10.
 */
   var $ = require("@alife/alpha-jquery/jquery"),
       Dialog = require("@alife/alpha-dialog/dialog"),
       cid = 0;

   var ExchangeMessage = function(callback, context, form){
       var iframe = $("<iframe>",{name: 'iframe-' + cid++ + "_"+new Date().getTime(),style:'display:none;'}),
           state = 0,
           message,
           dialog = new Dialog({
               content: '<div class="ui-loading"><i></i>Sending Message, Please wait...</div>',
               hasMask: false,
               width: 610,
               events : {
                   'click [data-role=close]' : function() {
                       this.destroy();
                   }
               }
           }).show();
       //先添加到DOM, 确保第一次的onload是后台返回结果触发的iframe
       $('body').append(iframe);

       function receiveMessage(e){
           if(!isFromGanges(e.origin)){
               return;
           }
           if(window.removeEventListener){
               window.removeEventListener('message', receiveMessage, false);
           }else{
               window.detachEvent('onmessage', receiveMessage);
           }
           var message = e.data;
           try{
               dialog.destroy();
               callback.call(context || null, JSON.parse(message));
           }catch(e){
               dialog.destroy();
               callback.call(context || null, {"code":7001});
           }
           iframe.remove();
       }

       /**
        *  Note:
        *  1. 不能在iframe上监听message, 跨域监听无效
        *  2. IE11无法获取不存在页面的window.name, 故优先使用postMessage方式
        */
       if(window.postMessage){
           if(window.addEventListener ){
               window.addEventListener('message', receiveMessage, false);
           }else{
               window.attachEvent('onmessage', receiveMessage);
           }
       }else {
           iframe.on("load", function(){
               if(state === 1){
                   // 处理后台返回json格式异常
                   try {
                       var message = JSON.parse(this.contentWindow.name);
                       callback.call(context || null, message);
                   }catch(e){
                       callback.call(context || null, {"code":7001});
                   }
                   // 提交信息后删除iframe
                   iframe.remove();
               }else {
                   state = 1;
                   this.contentWindow.location = "about:blank";//指向同域
               }
           });
       }
       //处理表单提交
       if(form){
           form.attr("target", iframe.attr("name"));
       }
   };

   function isFromGanges(origin){
        var host = getHost(origin);
        return host == 'us.message.alibaba.com' || host == 'cn.message.alibaba.com' || host == 'message.alibaba.com';
   }

   function getHost(origin){
       var a = document.createElement('a');
       a.href = origin;
       return a.hostname;
   }
   module.exports = ExchangeMessage;
